module.exports = __webpack_public_path__ + "static/media/marathon.fe133167.png";